import { useEffect, useState } from 'react'
import type { MenuItem } from '@/components/maia/types'
import {
  getStoredItemsOrFallback,
  type MenuItemCategory,
} from '@/lib/menuItems'

export function useMenuItems(
  category: MenuItemCategory,
  fallback: MenuItem[]
): MenuItem[] {
  const [items, setItems] = useState<MenuItem[]>(fallback)

  useEffect(() => {
    setItems(getStoredItemsOrFallback(category, fallback))
  }, [category, fallback])

  return items
}
